class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
document.addEventListener("DOMContentLoaded", () => {

  function createReserveTimer() {

    const cartDrawer =
      document.querySelector(".cart-drawer") ||
      document.querySelector("cart-drawer");

    if (!cartDrawer) return;

    if (document.querySelector(".reserve-timer-box")) return;

    const timerBox = document.createElement("div");

    timerBox.className = "reserve-timer-box";

    timerBox.innerHTML = `
      ⏳ Tu carrito expira en
      <span id="reserve-countdown">10:00</span>
    `;
    const target =
      cartDrawer.querySelector(".drawer__inner") ||
      cartDrawer.querySelector(".cart-drawer__content") ||
      cartDrawer;

   const subtotalSection =
document.querySelector('.mini-cart__footer') ||
document.querySelector('.cart-drawer__footer') ||
document.querySelector('.drawer__footer');

const benefits = document.createElement("div");

benefits.className = "cart-benefits";

benefits.innerHTML = `
  <div>✓ Envíos GRATIS a todo Chile</div>
  <div>✓ 2 años de garantía</div>
  <div>✓ Compra 100% segura</div>
`;

if (subtotalSection) {

  subtotalSection.prepend(benefits);
  subtotalSection.prepend(timerBox);

}


const secureBox = document.createElement("div");

secureBox.className = "cart-secure";

secureBox.innerHTML = `
 <div class="cart-bottom-info">
  3 cuotas sin interés • 🔒 Compra protegida
</div>

  <div class="cart-payment-icons">
  <img src="https://cdn.shopify.com/s/files/1/0617/2209/9823/files/Metodos_de_pago.png?v=1743534021" alt="Métodos de pago">
  </div>
`;

if (subtotalSection) {
  subtotalSection.append(secureBox);
}

    startCountdown();
  }

  function startCountdown() {

    let duration = 600;

    const countdown = document.getElementById("reserve-countdown");

    if (!countdown) return;

    const timer = setInterval(() => {

      const minutes = Math.floor(duration / 60);
      const seconds = duration % 60;

      countdown.innerHTML =
        `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

      duration--;

      if (duration < 0) {
        clearInterval(timer);
        countdown.innerHTML = "00:00";
      }

    }, 1000);
  }

  setInterval(createReserveTimer, 1000);

});